import { render, staticRenderFns } from "./OrderManagement.vue?vue&type=template&id=3920ee3a&scoped=true"
import script from "./OrderManagement.vue?vue&type=script&lang=js"
export * from "./OrderManagement.vue?vue&type=script&lang=js"
import style0 from "./OrderManagement.vue?vue&type=style&index=0&id=3920ee3a&prod&scoped=true&lang=css"
import style1 from "./OrderManagement.vue?vue&type=style&index=1&id=3920ee3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3920ee3a",
  null
  
)

export default component.exports